import request from './axios';

const base = '/api/tenant/web/webStation'

export const geHit = (param) => request({
    url: base+ '/hit',
    method: 'get',
    params: param
});

export const getStats = () => request({
    url: base+ '/stats',
    method: 'get'
});